var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCycle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1396_8407",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 121,
    height: 121
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.654297,
    y: 0.166992,
    width: 120,
    height: 120,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1396_8407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7346 102.716C37.7471 99.8059 30.3367 94.4855 24.5034 86.7546C18.67 79.0238 15.7534 70.1392 15.7534 60.1009C15.7534 57.4859 15.9696 54.8963 16.4021 52.3321C16.8346 49.768 17.5254 47.2613 18.4746 44.8121L7.62836 51.0721L5.22461 46.7746L24.6759 35.5246L35.9259 54.9471L31.5996 57.5434L24.0796 44.5434C22.9713 46.9859 22.1559 49.5276 21.6334 52.1684C21.1109 54.8092 20.8496 57.4855 20.8496 60.1971C20.8496 69.178 23.5225 77.1571 28.8684 84.1346C34.215 91.1121 41.0354 95.8317 49.3296 98.2934L46.7346 102.716ZM76.7146 40.0721V35.0721H91.5896C87.8205 30.3221 83.2275 26.6667 77.8109 24.1059C72.3942 21.5451 66.6763 20.2646 60.6571 20.2646C55.3688 20.2646 50.4263 21.2134 45.8296 23.1109C41.2338 25.0084 37.1634 27.6334 33.6184 30.9859L31.0221 26.4659C34.9971 22.9726 39.4909 20.2326 44.5034 18.2459C49.5159 16.2584 54.8684 15.2646 60.5609 15.2646C67.08 15.2646 73.2434 16.5738 79.0509 19.1921C84.8592 21.8113 89.9138 25.5821 94.2146 30.5046V17.5721H99.2146V40.0721H76.7146ZM77.4071 114.591L57.9546 103.246L69.2046 83.9184L73.5034 86.4184L65.7046 99.7259C75.6021 98.4376 83.87 94.0434 90.5084 86.5434C97.1459 79.0434 100.465 70.2517 100.465 60.1684C100.465 58.4184 100.348 56.6988 100.113 55.0096C99.88 53.3205 99.5196 51.6746 99.0321 50.0721H104.253C104.658 51.6746 104.96 53.3046 105.162 54.9621C105.364 56.6188 105.465 58.3222 105.465 60.0722C105.465 70.938 102.046 80.4876 95.2096 88.7209C88.3729 96.9551 79.6759 102.069 69.1184 104.062L79.9071 110.293L77.4071 114.591Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCycle);
export default __webpack_public_path__ + "static/media/cycle.4e11b742013ae1d5ad114042612a33b1.svg";
export { ForwardRef as ReactComponent };